/* eslint-disable no-alert */
/* eslint-disable no-plusplus */
/* eslint-disable no-underscore-dangle */
import Page from 'modules/_shared/components/Pages/Page';
import Logo from './account.svg';

const AdminCenter = () => (
  <Page>
    <h1>
      <img
        src={Logo}
        alt="Logo"
        style={{ height: '70px', marginRight: '20px' }}
      />
      SttokSign
    </h1>

    <hr />
  </Page>
);

export default AdminCenter;
